<template>
  <div>
    <md-card>
      <md-card-header>
        <div class="md-layout">
          <div class="md-layout-item md-size-90">
            <h4 class="title">Event Tickets</h4>
          </div>
          <div class="md-layout-item md-size-10 text-right">
            <md-button
              class="md-icon-button md-dense md-primary md-round"
              @click.prevent="newTicket"
            >
              <md-icon>add</md-icon>
              <md-tooltip md-direction="top"
                >Create a new Ticket<br />for this Event</md-tooltip
              >
            </md-button>
          </div>
        </div>
      </md-card-header>
      <md-card-content>
        <template v-if="tickets.length">
          <departure-tabs-ticket
            v-for="ticket in tickets"
            :key="ticket.id"
            :ticket="ticket"
            @removeTicket="removeTicket"
            @updateTicket="updateTicket"
          >
          </departure-tabs-ticket>
        </template>
        <md-empty-state
          v-else
          md-label="Tickets Please!"
          md-description="Let's give 'em something to book."
        >
          <md-button
            v-if="$allowed('crm.route.booking')"
            class="md-primary md-raised"
            @click="newTicket"
            >Create a New Ticket</md-button
          >
        </md-empty-state>
      </md-card-content>
    </md-card>

    <new-ticket-dialog
      :showNewTicketDialog.sync="showNewTicketDialog"
      :ticket="ticket"
      :departure="departure"
      @created="createTicket"
      @cancelled="showNewTicketDialog = false"
    ></new-ticket-dialog>
  </div>
</template>
<script>
import DepartureTabsTicket from "./DepartureTabsTicket.vue";
import NewTicketDialog from "./NewTicketDialog.vue";
import { mapGetters } from "vuex";

const ITicket = {
  departure_id: null,
  title: "",
  allocation: null,
  allocated: 0,
  prices: {
    gbp: null,
    eur: null,
    usd: null
  }
};

export default {
  components: {
    DepartureTabsTicket,
    NewTicketDialog
  },

  data() {
    return {
      showNewTicketDialog: false,
      ticket: {}
    };
  },

  mounted() {
    this.getTickets();
  },

  watch: {
    "departure.id"(nextId, prevId) {
      if (nextId && nextId !== prevId) {
        this.getTickets();
      }
    }
  },

  methods: {
    newTicket() {
      this.ticket = structuredClone(ITicket);
      this.showNewTicketDialog = true;
    },

    getTickets() {
      this.$store.dispatch("departures/fetchTickets", this.departure.id);
    },

    createTicket(ticket) {
      this.showNewTicketDialog = false;
      ticket.departure_id = this.departure.id;
      this.$store
        .dispatch("departures/createTicket", {
          ticket,
          departureId: this.departure.id
        })
        .then(() => {
          this.reloadDeparture();
        });
    },

    updateTicket(ticket) {
      this.$store
        .dispatch("departures/updateTicket", {
          ticket,
          departureId: this.departure.id
        })
        .then(() => {
          this.reloadDeparture();
        });
    },

    removeTicket(ticket) {
      this.$store
        .dispatch("departures/removeTicket", {
          ticket,
          departureId: this.departure.id
        })
        .then(() => {
          this.reloadDeparture();
        });
    },

    reloadDeparture() {
      this.$store.dispatch("departures/fetchDeparture", {
        tourId: this.departure.tour.id,
        departureId: this.departure.id
      });
    }
  },

  computed: {
    ...mapGetters("departures", ["tickets"]),
    departure() {
      return this.$store.state.departures.departure;
    },

    canEdit() {
      return true;
    }
  }
};
</script>
<style lang="scss" scoped>
.ticket-wrapper {
  border: 1px solid #ddd;
  border-radius: 7px;
  background-color: #f6f6f6;
  margin-bottom: 1em;
}

.price-row {
  margin-bottom: 1rem;
}

h6.title {
  display: flex;
  align-items: center;
}
</style>
